import { render, staticRenderFns } from "./CreditsModalRequestConfirmation.vue?vue&type=template&id=3b06ada8&"
import script from "./CreditsModalRequestConfirmation.vue?vue&type=script&lang=js&"
export * from "./CreditsModalRequestConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports